<template>
  <v-app app class="dash-app" dir="rtl">
    <!--    #8F989F -->
    <v-navigation-drawer
        color="#d6d9db"
        dark
        app
        right
        v-model="is_drawer_open"
        class="elevation-0"
    >
      <template v-slot:prepend>
        <v-img max-width="150px" class="mx-auto my-auto" :src="BACKEND_LINK + '/static/home/assets/images/logo.png'"></v-img>
      </template>

      <v-list >
        <v-list-item-group
            dark
            v-model="nav_n"
            @change="!nav_n?nav_n=0:''"
        >
          <v-list-item
              v-for="(item, i) in nav_items"
              :key="i"
              @click="nav_n=i;"
          >
            <v-list-item-icon v-html="item.icon">
            </v-list-item-icon>
            <v-list-item-content >
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar
        app
        color="#d6d9db"
        class="elevation-0"
    >
      <v-app-bar-nav-icon class="drawer-icon" @click="is_drawer_open=!is_drawer_open"></v-app-bar-nav-icon>

      <v-toolbar-title @click="nav_n=7" class="pointer">
        <v-avatar v-if="user['profile_picture']" class="mobile-d-none">
          <v-img :src="BACKEND_LINK+user.profile_picture"></v-img>
        </v-avatar>
        <v-icon v-else style="font-size: 4.5em">
          mdi-account-circle
        </v-icon>
        {{`${user.first_name} ${user.last_name}`}}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="mx-5">
        <Messages></Messages>
      </div>

      <div class="mx-5 mobile-d-none">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <v-icon v-if="is_connect" color="green">
                mdi-wifi-arrow-up-down
              </v-icon>
              <v-icon v-else color="red">
                mdi-wifi-off
              </v-icon>
            </div>
          </template>
          <div>
            وضعیت : {{is_connect?'متصل':'بدون ارتباط'}}
          </div>
        </v-tooltip>
      </div>
      <v-btn class="mr-5" text large @click="logout" color="red">
        <i class="mobile-d-none">خروج</i>
        <v-icon>mdi-logout</v-icon>
      </v-btn>

    </v-app-bar>
    <HomeDashboard v-if="nav_n === 0" :user="user" @change_nav="change_nav"></HomeDashboard>
    <HomeAccounts v-else-if="nav_n === 1"></HomeAccounts>
    <HomeTasks v-else-if="nav_n === 2"></HomeTasks>
    <HomeOrders v-else-if="nav_n === 3"></HomeOrders>
    <HomeReports v-else-if="nav_n === 4"></HomeReports>
    <HomeGetReports v-else-if="nav_n === 5"></HomeGetReports>
    <HomeDevicesData v-else-if="nav_n === 6"></HomeDevicesData>
    <HomeBarcodeRead v-else-if="nav_n === 7"></HomeBarcodeRead>
    <HomeBarcode v-else-if="nav_n === 8"></HomeBarcode>
    <HomeSupports v-else-if="nav_n === 9"></HomeSupports>
    <HomeProfile v-else-if="nav_n === 10" @page_1="nav_n=0;"></HomeProfile>
    <UserActivity v-else-if="nav_n === 11"></UserActivity>
  </v-app>

</template>
<style>
@import "@/assets/css/admin.css";
@import "@/assets/css/responsive.css";
</style>
<script>
import HomeDashboard from '../components/admin/dashboard'
import HomeAccounts from '../components/admin/accounts'
import HomeTasks from '../components/admin/tasks'
import HomeBarcode from '../components/admin/barcode'
import HomeBarcodeRead from '../components/admin/read_barcode'
import HomeSupports from '../components/admin/supports'
import HomeProfile from '../components/admin/profile'
import HomeManageContacts from '../components/admin/home/contacts'
import HomeManageProjects from '../components/admin/home/projects'
import HomeManageSlide from '../components/admin/home/slide'
import HomeReports from '../components/admin/reports'
import HomeGetReports from '../components/admin/get_reports'
import HomeDevicesData from '../components/admin/devices_data.vue'


import axios from "axios";
import Messages from "@/components/messages.vue";
import UserActivity from "@/components/user-activity.vue";
import HomeOrders from "@/components/Orders/base.vue";

export default {
  name: 'User3View',
  components: {
    HomeOrders,
    UserActivity,
    HomeDashboard,
    HomeAccounts,
    HomeTasks,
    HomeBarcodeRead,
    HomeBarcode,
    HomeSupports,
    HomeProfile,
    HomeManageContacts,
    HomeManageProjects,
    HomeManageSlide,
    HomeReports,
    HomeGetReports,
    Messages,
    HomeDevicesData
  },
  data () {
    return {
      active_btn :'',
      is_connect: navigator.onLine,
      is_drawer_open:true,
      nav_n:0,
      key: localStorage.getItem('key'),
      user:null,
      network_notification:null,
      nav_items: [
        { title: 'میز کار', icon: '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M8 0L0 6V18H5V11H11V18H16V6L8 0Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'کاربران', icon: '<svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V14H14V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C15.19 8.89 16 10.02 16 11.5V14H22V11.5C22 9.17 17.33 8 15 8Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'لیست کارها', icon: '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM11 16H4V14H11V16ZM14 12H4V10H14V12ZM14 8H4V6H14V8Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'لیست خرید', icon: '<svg width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M704 704h64v192H256V704h64v64h384v-64zm188.544-152.192C894.528 559.616 896 567.616 896 576a96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0c0-8.384 1.408-16.384 3.392-24.192L192 128h640l60.544 423.808z"/></svg>\n' },

        { title: 'گزارش عملیات', icon: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M17 10H1C0.45 10 0 10.45 0 11V17C0 17.55 0.45 18 1 18H17C17.55 18 18 17.55 18 17V11C18 10.45 17.55 10 17 10ZM4 16C2.9 16 2 15.1 2 14C2 12.9 2.9 12 4 12C5.1 12 6 12.9 6 14C6 15.1 5.1 16 4 16ZM17 0H1C0.45 0 0 0.45 0 1V7C0 7.55 0.45 8 1 8H17C17.55 8 18 7.55 18 7V1C18 0.45 17.55 0 17 0ZM4 6C2.9 6 2 5.1 2 4C2 2.9 2.9 2 4 2C5.1 2 6 2.9 6 4C6 5.1 5.1 6 4 6Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'خروجی گزارش عملیات', icon: '<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M10 0H2C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM12 16H4V14H12V16ZM12 12H4V10H12V12ZM9 7V1.5L14.5 7H9Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'مانیتورینگ', icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14.9 13.49L13.5 14.89C13.3 15.09 12.99 15.09 12.79 14.89L9.38 11.48C8.16 11.91 6.74 11.65 5.76 10.67C4.65 9.56 4.46 7.88 5.17 6.57L7.52 8.92L8.93 7.51L6.58 5.17C7.9 4.46 9.57 4.65 10.68 5.76C11.66 6.74 11.92 8.16 11.49 9.38L14.9 12.79C15.09 12.98 15.09 13.3 14.9 13.49Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'بارکد خوان', icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
              '<rect width="24" height="24" fill="url(#pattern0)"/>\n' +
              '<defs>\n' +
              '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">\n' +
              '<use xlink:href="#image0_472_4296" transform="scale(0.0104167)"/>\n' +
              '</pattern>\n' +
              '<image id="image0_472_4296" width="96" height="96" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAABx0lEQVR4nO3bzU3DMACG4Q8KOQGDkI4BkyDGAUVUHYa/KWACugHpjSI4JAeQ2thJXH1J8z6Sb8aJ/dIK0VQCAAAAAAAAAACH7ihizk/LNULzQ9qu1/f6+75e4xkfB34Ye0YAMwKYEcCMAGYEMCOAGQHMCGBGADMCmBHAjABmBDAjgBkBzAhgRgAzApgRwIwAZgQwIwAAAAAAjMBcUiHpXdJa1fPxUx7r+iyK+mz2JpO0lPQ9gE0PdWwkLeqzSiqT9DqADY5lvChxhOUANjW28dDppLeYq3ppuTc0trGRlIcON+a/obeSZhHz8N9M0k1oUkyAq/73MlnXoQkxX1MtJZ31v5dJKiVdNE1I8T3hLmu2uV5ovbbzU18vhO8JDxkBzAhgRgAzApgRwIwAZgQwI4AZAcwIYEYAMwKYEcCMAGYEMCOAGQHMCGB2EjGnlHTeYs22n5mmXq/v9VPe/2doQswrYJXgRqbqIzQhJsBTghuZqscUi+Ti0cSujyZedjjvrRYD2NDYRtHppHfIVD1y7d7UWMazpNNOJ90gU/XINW9Hu8eXqt/85If/Vy7pXtKbqj9R3Zt2j7I+izslfM8HAAAAAADA4fkF8J7/cQik4wkAAAAASUVORK5CYII="/>\n' +
              '</defs>\n' +
              '</svg>\n' },
        { title: 'دریافت بارکد', icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
              '<rect width="24" height="24" fill="url(#pattern0)"/>\n' +
              '<defs>\n' +
              '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">\n' +
              '<use xlink:href="#image0_472_4299" transform="scale(0.0104167)"/>\n' +
              '</pattern>\n' +
              '<image id="image0_472_4299" width="96" height="96" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAAx0lEQVR4nO3RQQqAMAwAwer//6w/sBYpCzJzThPojgEAAAAAAPzd8WLmWtwxm59Z3ff1/u57j398Th6zmQAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyAmQEyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMAAAAAAABgsxtTjgaAXK0fsQAAAABJRU5ErkJggg=="/>\n' +
              '</defs>\n' +
              '</svg>\n' },
        { title: 'پشتیبانی', icon: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM9.01 15C8.31 15 7.75 14.44 7.75 13.74C7.75 13.03 8.31 12.49 9.01 12.49C9.72 12.49 10.26 13.03 10.26 13.74C10.25 14.43 9.72 15 9.01 15ZM12.02 7.6C11.26 8.71 10.54 9.06 10.15 9.77C9.99 10.06 9.93 10.25 9.93 11.18H8.11C8.11 10.69 8.03 9.89 8.42 9.2C8.91 8.33 9.84 7.81 10.38 7.04C10.95 6.23 10.63 4.71 9.01 4.71C7.95 4.71 7.43 5.51 7.21 6.19L5.56 5.49C6.01 4.15 7.22 3 8.99 3C10.47 3 11.48 3.67 12 4.52C12.44 5.24 12.7 6.59 12.02 7.6Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'پروفایل', icon: '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM9 6C10.66 6 12 7.34 12 9C12 10.66 10.66 12 9 12C7.34 12 6 10.66 6 9C6 7.34 7.34 6 9 6ZM15 18H3V16.6C3 14.6 7 13.5 9 13.5C11 13.5 15 14.6 15 16.6V18Z" fill="black"/>\n' +
              '</svg>\n' },
        { title: 'ورود و خروج من', icon: '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
              '<path d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM9 6C10.66 6 12 7.34 12 9C12 10.66 10.66 12 9 12C7.34 12 6 10.66 6 9C6 7.34 7.34 6 9 6ZM15 18H3V16.6C3 14.6 7 13.5 9 13.5C11 13.5 15 14.6 15 16.6V18Z" fill="black"/>\n' +
              '</svg>\n' },
      ],}
  },
  created() {
    this.get_user_information();
    setInterval(this.updateConnectionStatus, 4000);
    if(! navigator.onLine){
      this.$snotify.error("اتصال به شبکه برقرار نیست!", 'خطای اینترنت', {timeout: 0,});
    }

  },
  watch: {
    nav_n(nav_n){
      if(this.WIDTH < 1264){
        this.is_drawer_open = false;
      }
    }
  },
  methods:{
    change_nav(nav){
      if(nav===5)nav=6;
      this.nav_n = nav;
    },
    updateConnectionStatus(){
      if(! navigator.onLine){
        if(this.is_connect){
          this.network_notification = this.$snotify.error("اتصال به شبکه برقرار نیست!", 'برقراری ارتباط', {timeout: 0,});
        }
      }else{
        if (!this.is_connect){
          if (this.network_notification) {
            this.$snotify.remove(this.network_notification.id);
          }
          this.$snotify.success("اتصال مجدد برقرار شد", ' برقراری ارتباط', {timeout: 4000,});
        }
      }
      this.is_connect = navigator.onLine;

    },
    get_user_information() {
      if (this.key) {
        axios.get(`${this.BACKEND_LINK}/api/account/info/`, {
          headers: {'Authorization': `Token ${this.key}`}
        }).then((response) => {
          if (response.data.id) {
            this.user = response.data;
          }
        })
      }else{
        this.$router.push('/');
      }
    },
    logout(){
      axios.get(this.BACKEND_LINK + '/api/account/logout/', {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.data.msg === 'logged out.'){
          this.$snotify.warning(` در حال خارج شدن از کاربر :  "${this.user["get_full_name"]}"`, 'خروج...');
          setTimeout(()=>{
            localStorage.removeItem('key')
            this.$router.push('/')
          },2000);
        }
      });
    }
  }
}
</script>
